import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { fetchTableData } from '../../../../Api/ApiMethods';
import { shouldToastError } from '../../../../Api/utils';
import { TITLE_TR_REGEX } from '../../../../_helper/regexHandler';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const DistrictDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedDistrict, refreshData }) => {
    const initialDistrictData = {
        id: '',
        title: '',
        city: []
    };

    const customHandlers = useMemo(() => ({
        city: (value, prev) => ({ ...prev, city: value ? [value] : [] }),
    }), []);

    const validationSchema = useMemo(() => ({
        title: {
            required: true,
            message: 'İlçe adı zorunludur.',
            regex: TITLE_TR_REGEX,
            regexMessage: 'İlçe adı sadece harf ve boşluk içerebilir minimum 3 karakter maksimum 50 karakter desteklemektedir.',
        },
        city: {
            required: true,
            message: 'Şehir seçimi zorunludur.',
        },
    }), []);

    const {
        formData: districtData,
        errors,
        resetForm,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedDistrict,
        initialData: initialDistrictData,
        toggle,
        mapSelectedToData: ({ initialData, selectedItem }) => {
            let cityArray = [];
            if (selectedItem?.city) {
                if (typeof selectedItem.city === 'object' && selectedItem.city !== null && selectedItem.city.id) {
                    cityArray = [selectedItem.city.id];
                } else if (typeof selectedItem.city === 'string' || typeof selectedItem.city === 'number') {
                    cityArray = [selectedItem.city];
                } else if (Array.isArray(selectedItem.city) && selectedItem.city.length > 0) {
                    cityArray = [selectedItem.city[0]];
                }
            }

            return {
                ...initialData,
                ...selectedItem,
                title: selectedItem?.title || '',
                city: cityArray,
            };
        },
        normalizeInput: true,
        customHandlers,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            refreshData,
            componentName: 'İlçe',
            buildPayload: (data) => ({
                ...data,
                title: data.title,
                city: data.city,
            }),
        },
    });
    const [cities, setCities] = useState([]);
    const cityApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/city';

    // Modal açıldığında şehir listesini ve form verisini hazırlar
    useEffect(() => {
        if (isOpen) {
            fetchTableData({
                apiEndpoint: cityApiUrl,
                page: 1,
                pageSize: 100,
                search: '',
                 setDataCallback: (data) => {
                    if (Array.isArray(data)) {
                        setCities(data);
                    } else {
                        setCities([]);
                        toast.error("Şehirler yüklenemedi.");
                    }
                 },
                setTotalRowsCallback: () => {}
             }).catch(error => {
                 if (shouldToastError(error)) {
                     toast.error("Şehirler yüklenirken bir hata oluştu.");
                 }
                 setCities([]);
             });

            if (mode !== 'modify' || !selectedDistrict) {
                resetForm();
            }
        }
    }, [isOpen, mode, selectedDistrict, cityApiUrl]);

    const getModalTitle = () => {
        return mode === 'add' ? 'İlçe Ekle' : 'İlçe Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    const selectedCityId = (districtData.city && districtData.city.length > 0) ? districtData.city[0] : '';

    return (
        <Modal isOpen={isOpen} toggle={handleCancel}>
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">İlçe Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={districtData.title || ''}
                            onChange={handleInputChange}
                            invalid={!!errors.title}
                        />
                         {errors.title && <div className="text-danger small mt-1">{errors.title}</div>}
                    </FormGroup>
                    <FormGroup>
                        <Label for="city">Şehir <span className="text-danger">*</span></Label>
                        <Input
                            type="select"
                            id="city"
                            name="city"
                            value={selectedCityId}
                            onChange={handleInputChange}
                            invalid={!!errors.city}
                        >
                            <option value="">Şehir Seçiniz</option>
                            {cities && cities.map(city => (
                                <option key={city.id} value={city.id}>
                                    {city.title}
                                </option>
                            ))}
                        </Input>
                        {errors.city && <div className="text-danger small mt-1">{errors.city}</div>}
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                 <button className="btn btn-outline-success rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                </button>
                <button className="btn btn-outline-danger rounded-pill" onClick={handleCancel}>
                    İptal
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default DistrictDataModal;
